import React from 'react';

import styles from './TextBlock.scss';

const TextBlock = ({
  type,
  headline,
  headlineIcon,
  backgroundIcon,
  description,
  embed,
}) => {
  const headlineIconUri = headlineIcon
    ? require(`./${headlineIcon}`)
    : undefined;

  const backgroundIconUri = backgroundIcon
    ? require(`./${backgroundIcon}`)
    : undefined;
  const backgroundStyle = backgroundIconUri
    ? { backgroundImage: `url(${backgroundIconUri})` }
    : {};
  const backgroundClass = backgroundIconUri
    ? ' TextBlock--with-background-icon'
    : '';
  const typeClass = type ? ` TextBlock--${type}` : '';
  return (
    <div
      className={`TextBlock${typeClass}${backgroundClass}`}
      style={backgroundStyle}
    >
      {headlineIconUri ? (
        <img className="TextBlock__icon" src={headlineIconUri} />
      ) : null}
      <div className="TextBlock__content">
        {headline ? (
          <div className="TextBlock__headline">{headline}</div>
        ) : null}
        {description}
      </div>
    </div>
  );
};

export default TextBlock;
